type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE" | "GQL";

const STYLES: Record<Method, string> = {
  GET: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  POST: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  PUT: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  PATCH: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  DELETE: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  GQL: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/30",
};

export function MethodBadge({ method }: { method: Method }) {
  return (
    <span
      className={`inline-flex items-center font-mono text-xs font-semibold uppercase tracking-wider rounded-md border px-2 py-1 ${STYLES[method]}`}
    >
      {method}
    </span>
  );
}
